var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-name is-flex-col"},[_c('span',[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('span',{staticClass:"text-gray is-size-7"},[_vm._v(_vm._s(_vm.helper))])])
}
var staticRenderFns = []

export { render, staticRenderFns }